/**
 * Edit component
 */
import { __ } from '@wordpress/i18n';
import { useBlockProps, InspectorControls } from '@wordpress/block-editor';
import { PanelBody, ToggleControl } from '@wordpress/components';

export default function Edit( { attributes, setAttributes } ) {
	const { showIcon } = attributes;
	const blockProps = useBlockProps( {
		className: 'nemtly-event-location',
	} );

	return (
		<>
			<InspectorControls>
				<PanelBody title={ __( 'Settings', 'nemtly-booking' ) }>
					<ToggleControl
						label={ __( 'Show Icon', 'nemtly-booking' ) }
						checked={ showIcon }
						onChange={ ( value ) =>
							setAttributes( { showIcon: value } )
						}
					/>
				</PanelBody>
			</InspectorControls>

			<div { ...blockProps }>
				{ showIcon && (
					<svg
						className="nb-w-5 nb-h-5 nb-mr-2"
						fill="currentColor"
						viewBox="0 0 20 20"
					>
						<path
							fillRule="evenodd"
							d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
							clipRule="evenodd"
						/>
					</svg>
				) }
				<span className="nemtly-location-preview">
					{ __( '123 Event St, City, Country', 'nemtly-booking' ) }
				</span>
			</div>
		</>
	);
}
